export const RECOMMEND_A_PRODUCT_TRIGGER = '{RECOMMEND_A_PRODUCT}';
